import teacher1 from "../assets/images/ustoz1.jpg";

export const teachersData = [
  {
    key: 1,
    id: 1,
    name: "Movluda",
    lastName: "Karimova",
    img: teacher1,
    experience: "7+",
    students: "2000+",
    workplace: "Maktabimiz rahbari",
    achievments: "Oliy toifali pedagog",
    moreInfo:
      "Oxirgi 1 yilda maktabimiz rahbari lavozimida o'z ish faoliyatlarini olib boradilar va qisqa vaqt ichida ko'plab o'quvchilar va o'qituvchilar ko'nglidan joy olishga ulgurgan professional pedagog",
  },
  {
    key: 2,
    id: 2,
    name: "Indira",
    lastName: "Saidnazarova",
    img: teacher1,
    experience: "5+",
    students: "500+",
    workplace: "Ma'naviyat ishlari bõyicha õrinbosae",
    achievments: "Oliy toifali pedagog",
    moreInfo:
      "Oxirgi 3 yilda maktabimiz rahbari lavozimida o'z ish faoliyatlarini olib boradilar va qisqa vaqt ichida ko'plab o'quvchilar va o'qituvchilar ko'nglidan joy olishga ulgurgan professional pedagog",
  },
  {
    key: 3,
    id: 3,
    name: "Diloram",
    lastName: "Zufarova",
    img: teacher1,
    experience: "25+",
    students: "2000+",
    workplace: "Ona-tili va adabiyot ustoz",
    achievments: "Eng fidokor ustoz medali sohibasi",
    moreInfo:
      "Bizning maktabimizda 25 yildan oshiq o'z faoliyatlarini olib boradilar. O'quvchilari ko'plab olimpiada va tanlovlarda faxrli o'rinlarni olib keladi",
  },
  {
    key: 4,
    id: 4,
    name: "Khilola",
    lastName: "Ikromova",
    img: teacher1,
    experience: "10+",
    students: "500",
    workplace: "Ingliz tili o'qituvchisi",
    achievments: "IELTS C1 sohibasi",
    moreInfo:
      "Ushbu o'qituvchimiz o'qitgan o'quvchilar hozirda ingliz tilida erkin so'zlay oladilar va IELTS, CEFR kabi boshqa xalqaro sertifikatlari sohiblari",
  },
  {
    key: 5,
    id: 5,
    name: "Dilfuza",
    lastName: "Xamrayeva",
    img: teacher1,
    experience: "12+",
    students: "700",
    workplace: "English Teacher",
    achievments: "Kimyo fanidan oliy toifali o'qituvchi unvoni",
    moreInfo:
      "Ushbu o'qituvchimiz o'qitgan o'quvchilarning ko'pi oliygohlarga grant va kontrakt asosida o'qishga kirishgan",
  },
  {
    key: 6,
    id: 6,
    name: "Zilola",
    lastName: "Djalilova",
    img: teacher1,
    experience: "20+",
    students: "1000+",
    workplace: "Ona tili va adabiyot o'qituvchisi",
    achievments: "Ko'plab medallar sohibasi",
    moreInfo:
      "O'qituvchimizning darslari qiziqarli va interfaol bo'lganligi sababli ularni barcha o'quvchilar hurmat qiladi va ular sababli o'z bilimlarini orttiradi",
  },
  {
    key: 7,
    id: 7,
    name: "Dilorom",
    lastName: "Xasanova",
    img: teacher1,
    experience: "12+",
    students: "800+",
    workplace: "Informatika fani o'qituvchisi",
    achievments:
      "Informatika fani bo'yicha o'qituvchilar musobaqasida faxrli o'rinni egallag ustoz",
    moreInfo:
      "Doimo o'quvchilarga informatika va sun'iy intellektlar haqida dars berib, ularning qiziqishlarini yanada oshiradi",
  },
  {
    key: 8,
    id: 8,
    name: "Marina",
    lastName: "Anatolevna",
    img: teacher1,
    experience: "10+",
    students: "800+",
    workplace: "Matematika fani o'qituvchisi",
    achievments: "No achievments",
    moreInfo:
      "Qattiqo'lliklari va talabchan ustozliklari bilan boshqalardan ajralib turadilar hamda bolalarga mukammal bilm berib boradilar",
  },
  {
    key: 9,
    id: 9,
    name: "Ulfat",
    lastName: "Furkatovna",
    img: teacher1,
    experience: "18+",
    students: "1000+",
    workplace: "Rus sinflarga ona tili va adabiyot o'qituvchisi",
    achievments: "Oliy toifali ustozlardan biri",
    moreInfo:
      "Rus sinflarga ona tili hamda adabiyotdan mukammal bilm beradilar va interfaol darslar o'tadilar",
  },
  {
    key: 10,
    id: 10,
    name: "Barno",
    lastName: "Baxtiyarovna",
    img: teacher1,
    experience: "10+",
    students: "500+",
    workplace: "Boshlang'ich sinf o'qituvchisi",
    achievments: "No achievments",
    moreInfo:
      "Shu paytgacha ko'plab 1-sinfga qadam bosganlarni to 4-sinfga qadar bilm berib, ularga ilk savodxonlikni o'rgatish bo'yicha maktabimiz professional ustozlaridan biri",
  },
];
